import PlanService from './PlanService';

const getChangeType = (currentPlanLabel, newPlanLabel) => {
  if (PlanService.isFibreUpgrade(currentPlanLabel, newPlanLabel)) {
    return 'FibreUpgrade';
  } else if (PlanService.isDSLChange(currentPlanLabel, newPlanLabel)) {
    return 'DSLMove';
  }
  return 'SpeedChange';
};

const getOpportunityStage = (currentPlanLabel, newPlanLabel) => {
  if (newPlanLabel !== currentPlanLabel) {
    return 'Move and Change';
  }
  return 'Move Of Address';
};

const ChangeService = {
  getNewPlanLabel: (availablePlans, currentPlan, planId, isMove, speedChangeOption) => {
    if (isMove && speedChangeOption === 'keepSpeed') {
      return currentPlan;
    }
    const otherPlans = PlanService.getOtherPlans(availablePlans, currentPlan);
    const plan = planId
      ? otherPlans.find(otherPlan => otherPlan.planId === planId)
      : otherPlans[0];
    return plan.label;
  },
  getChangeRequestPayload: (customer, newPlanLabel, isMove, connectionDate, toAddress) => {
    if (isMove) {
      return {
        changeType: getOpportunityStage(customer.currentPlan, newPlanLabel),
        productOffer: newPlanLabel,
        dateToBeConnected: connectionDate.getTime(),
        mobileNumber: customer.mobileNumber,
        building: toAddress.building,
        street: toAddress.street,
        suburb: toAddress.suburb,
        city: toAddress.city,
        samId: toAddress.samIds[0],
        tui: toAddress.tui,
        term: PlanService.getSalesforceTerm(customer.contract),
        type: getChangeType(customer.currentPlan, newPlanLabel)
      };
    }
    return {
      changeType: 'Change Of Plan',
      productOffer: newPlanLabel,
      dateToBeConnected: new Date().getTime(),
      mobileNumber: customer.mobileNumber,
      building: customer.building,
      street: customer.streetName,
      suburb: customer.suburb,
      city: customer.city,
      samId: customer.samId,
      tui: customer.tui,
      term: PlanService.getSalesforceTerm(customer.contract),
      type: getChangeType(customer.currentPlan, newPlanLabel)
    };
  },
  canMove: (props) => {
    if (props.error && props.error.message) {
      // If there's an error from the backend the customer cannot move address.
      return false;
    }
    // If the customer current plan is available at the new address or there are other speeds available
    // the customer can move address.
    return props.isCurrentPlanAvailable || props.availablePlans.length > 0;
  }
};

export default ChangeService;



/** WEBPACK FOOTER **
 ** ./src/services/ChangeService.js
 **/